import React from 'react';
import { Box, Typography } from '@mui/material';

const HeaderTitle = ({ title, subtitle, actions }) => {
    return (
        <Box display="flex" flexDirection="row" width="100%" justifyContent="space-between" alignItems="flex-start">
            <Box display="flex" flexDirection="column" alignItems="flex-start" rowGap={0}>
                {title && (
                    <Typography variant="h6" gutterBottom mb={0}>{title}</Typography>
                )}
                {subtitle && (
                    <Typography variant="body1" fontSize={"12px"} color='text.secondary'>{subtitle}</Typography>
                )}
                <Box sx={{ height: '2px', background: (theme) => theme.palette.primary.main, my: 1, width: '60px' }}>
                </Box>
            </Box>
            {actions && (
                <Box display="flex" flexDirection="row" alignItems="center" columnGap="10px">
                    {actions}
                </Box>
            )}
        </Box>
    );
};

export default HeaderTitle;

